import React, { useEffect } from 'react';
import { Modal, Form, Input, InputNumber } from 'antd';

const ProductionJointsModal = ({ visible, mode, initialData, onCancel, onOk, groupScope }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      form.setFieldsValue(initialData);
    }
  }, [visible, initialData, form]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        onOk(values);
        form.resetFields();
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  const renderTitle = () => {
    if (mode === 'addGroup') return 'Add Pipe Group';
    if (mode === 'editGroup') return 'Edit Pipe Group';
    if (mode === 'addPipeData') return 'Add Pipe Data';
    if (mode === 'editPipeData') return 'Edit Pipe Data';
    if (mode === 'viewPipeData') return 'Information';
    if (mode === 'deletePipeData') return 'Delete Production Joint';
    if (mode === 'deleteGroup') return 'Delete Pipe Group';
    return '';
  };

  const isReadOnly = mode === 'viewPipeData';
  const isDeleteMode = mode === 'deletePipeData' || mode === 'deleteGroup';

  return (
    <Modal
      visible={visible}
      title={renderTitle()}
      onCancel={onCancel}
      onOk={handleOk}
      okText={isReadOnly ? null : isDeleteMode ? 'Delete' : mode.includes('add') ? 'OK' : 'Update'}
      cancelText="Cancel"
      okType={isDeleteMode ? 'danger' : 'primary'}
      destroyOnClose
    >
      {isDeleteMode ? (
        <div style={{ padding: '20px 0' }}>
          <p style={{ fontSize: '16px', marginBottom: '16px' }}>
            {mode === 'deletePipeData'
              ? 'Are you sure you want to delete this production joint?'
              : 'Are you sure you want to delete this pipe group?'}
          </p>
          <p style={{ color: '#666', fontSize: '14px' }}>
            {mode === 'deletePipeData'
              ? 'This action cannot be undone. The production joint and all its associated data will be permanently removed.'
              : 'This will delete the group and all its sub-joints. This action cannot be undone.'}
          </p>
        </div>
      ) : (
        <Form form={form} layout="vertical" name="production_joints_form">
          {mode.includes('Group') && (
            <>
              <Form.Item
                name="name"
                label="Pipe Group Name"
                rules={[{ required: true, message: 'Please input the group name!' }]}
              >
                <Input readOnly={isReadOnly} />
              </Form.Item>
              <Form.Item
                name="scope"
                label="Scope"
                rules={[{ required: true, message: 'Please input the scope!' }]}
              >
                <InputNumber style={{ width: '100%' }} readOnly={isReadOnly} />
              </Form.Item>
            </>
          )}
          {mode.includes('PipeData') && (
            <>
              <Form.Item
                name="pipeDescription"
                label="Pipe Description"
                rules={[{ required: true, message: 'Please input the description!' }]}
              >
                <Input readOnly={isReadOnly} />
              </Form.Item>
              <Form.Item name="factoryCoating" label="Factory Coating">
                <Input readOnly={isReadOnly} />
              </Form.Item>
              <Form.Item name="fjcType" label="FJC Type">
                <Input readOnly={isReadOnly} />
              </Form.Item>
              <Form.Item name="fjcThickness" label="FJC Thickness">
                <InputNumber style={{ width: '100%' }} readOnly={isReadOnly} />
              </Form.Item>
              <Form.Item name="unit" label="Unit">
                <Input readOnly={isReadOnly} />
              </Form.Item>
              <Form.Item
                name="scope"
                label={`Scope (Must be less than or equal to ${groupScope})`}
                rules={[
                  { required: true, message: 'Please input the scope!' },
                  {
                    type: 'number',
                    max: groupScope,
                    message: `Scope cannot exceed parent group's scope of ${groupScope}.`,
                  },
                ]}
              >
                <InputNumber style={{ width: '100%' }} readOnly={isReadOnly} />
              </Form.Item>
              <Form.Item name="pipeStringId" label="Pipe String ID">
                <Input readOnly={isReadOnly} />
              </Form.Item>
            </>
          )}
        </Form>
      )}
    </Modal>
  );
};

export default ProductionJointsModal;
